module.exports = __webpack_public_path__ + "static/media/file-user.c34eb3a6.svg";